const SetupWizardStepMixin = {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disableNextButton: {
      type: [Boolean, Number],
      default: false,
    },
  },
  computed: {
    editModeActive() {
      return this.active && this.editMode
    },
    createMode() {
      return !this.editMode
    },
    createModeActive() {
      return this.active && this.createMode
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        if (this.editModeActive && this.isMounted) {
          this.disableSubmit(false)
        }
      },
    },
    active() {
      if (this.createModeActive && this.$refs.datatable?.reload) {
        this.$refs.datatable.reload()
      }
    },
  },
  data() {
    return {
      isMounted: false,
    }
  },
  mounted() {
    this.$nextTick(() => { this.isMounted = true })
  },
  methods: {
    disableSubmit(disable = false) {
      setTimeout(() => {
        if (!this.active) return
        this.$emit('update:disable-next-button', disable)
      }, 200)
    },
  },
}

export default SetupWizardStepMixin
